module.exports = __webpack_public_path__ + "static/media/рай.3762cbf4.svg";